"use client";
import SectionPage from "@/components/common/section-page";

import {Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList,} from "@/components/ui/breadcrumb";
import CardTitle from "@/components/common/card-title";
import AwesomeCard from "@/components/common/awesome-card";
import CiInteractiveMap, {ciInteractiveMapMarkers,} from "@/components/site-officiel/accueil/ci-interactive-map";
import { useNavigate } from "react-router-dom";
import ImageGallery from "@/components/common/image-gallery";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className={"flex flex-col gap-6 pb-6 bg-slate-100"}>
      <CardTitle
        title={"Nos Régions"}
        backgroundImgSrc={"/images/card-title/Nos-Regions.jpg"}
      />

      {/* Breadcrumb */}
      <SectionPage sectionType="2xl">
        <div className={"flex justify-between items-center"}>
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink href={"/"}>Nos Régions</BreadcrumbLink>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>
      </SectionPage>

      {/* Présentation */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"LE SUD-OUEST : LA PERLE DE LA CÔTIERE"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          Doté de magnifique paysage rocheux où se mêlent flore et océan , La
          plage de Grand-Béréby est juste impressionnante. Grand-Béréby
          accueille la 1ère aire marine protégée de Côte d’Ivoire à 378 km
          d’Abidjan. 2 Km plus loin, du côté de Taboulé on assiste à une vague
          de migration saisonnière de tortues marines venant de divers horizons
          pour la saison de ponte où elles séjournent jusqu’à l’éclosion des
          œufs.
          <br />
          <br />
          La balade sur le lac Nero en canoë kayak vous donnera l’occasion
          d’atteindre le sanctuaire des singes sauvages que vous pourrez nourrir
          et également de découvrir les embarcations artisanales des pêcheurs
          plus originales les unes des autres.
          <br />
          <br />
          La région possède de nombreuses plages, une faune et une forêt riche
          autour de laquelle s’est développée une gastronomie à base de poissons
          et crustacés cuisinés de manière originale, selon des recettes
          européennes ou locales telles que le kédjénou de langouste qui ne
          laisse aucun visiteur indifférent.
        </AwesomeCard>
      </SectionPage>

      {/* galerie */}
      <SectionPage sectionType="2xl">
        <AwesomeCard className={"bg-white"} titleClassName={"text-bleu-marine"}>
          <div className={'mt-1'}>
            <ImageGallery images={
              Array.from({ length: 4 }).map((_, index) => ({
                src: `/images/nos-regions/sud-ouest${index + 1}.jpg`,
                alt: `image${index + 1}`,
                width: 700,
                height: 700,
              }))
            } aspectRatio={"video"} />
          </div>
        </AwesomeCard>
      </SectionPage>

      {/* Villes et Régions */}
      <SectionPage sectionType="2xl">
        <AwesomeCard
          title={"Villes et Régions"}
          className={"bg-white text-muted-foreground"}
          titleClassName={"text-bleu-marine"}
        >
          <div className={"flex justify-center w-full"}>
            <CiInteractiveMap
              strokeColor={"#ffffff"}
              markers={ciInteractiveMapMarkers(navigate)}
            />
          </div>
        </AwesomeCard>
      </SectionPage>
    </div>
  );
}
